// Language model based on ChannelplayJobs_V2 implementation
export class Language {
  constructor({ nativeName, code, name }) {
    this.nativeName = nativeName;
    this.code = code;
    this.name = name;
  }

  static fromJson(json) {
    return new Language({
      nativeName: json.nativeName || json.localName,
      code: json.code,
      name: json.name,
    });
  }

  toJson() {
    return {
      nativeName: this.nativeName,
      code: this.code,
      name: this.name,
    };
  }
}

// Supported languages list based on ChannelplayJobs_V2
export const SUPPORTED_LANGUAGES = [
  new Language({
    code: 'en',
    name: 'English',
    nativeName: 'English',
  }),
  new Language({
    code: 'hi',
    name: 'Hindi',
    nativeName: 'हिन्दी',
  }),
  new Language({
    code: 'bn',
    name: 'Bengali',
    nativeName: 'বাংলা',
  }),
  new Language({
    code: 'ta',
    name: 'Tamil',
    nativeName: 'தமிழ்',
  }),
  new Language({
    code: 'te',
    name: 'Telugu',
    nativeName: 'తెలుగు',
  }),
  new Language({
    code: 'mr',
    name: 'Marathi',
    nativeName: 'मराठी',
  }),
  new Language({
    code: 'gu',
    name: 'Gujarati',
    nativeName: 'ગુજરાતી',
  }),
  new Language({
    code: 'kn',
    name: 'Kannada',
    nativeName: 'ಕನ್ನಡ',
  }),
  new Language({
    code: 'ml',
    name: 'Malayalam',
    nativeName: 'മലയാളം',
  }),
];
